import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import { useFormContext } from 'react-hook-form'
import { Button } from '~/components/Global/Interactions/Button/Button'
import { ButtonVariation } from '~/components/Global/Interactions/Button/ButtonVariation'

type ShortlistAnswerButtonProps = {
  name: string
  value: 'yes' | 'no'
  icon: IconDefinition
  label: string
  onAnswer?: () => void
}

export const ShortlistAnswerButton = ({
  name,
  value,
  icon,
  label,
  onAnswer
}: ShortlistAnswerButtonProps): ReactElement => {
  const { watch, setValue } = useFormContext()
  const isActive = watch(name) === value
  const activeVariation =
    value === 'yes' ? ButtonVariation.Success : ButtonVariation.Danger

  return (
    <Button
      type="button"
      variation={isActive ? activeVariation : ButtonVariation.Neutral}
      buttonSize="small"
      title={label}
      aria-label={label}
      aria-pressed={isActive}
      onClick={() => {
        if (isActive) return
        setValue(name, value, { shouldValidate: true, shouldDirty: true })
        onAnswer?.()
      }}
    >
      <FontAwesomeIcon icon={icon} />
    </Button>
  )
}
